import { useContext } from 'react';
import { LanguageContext } from 'src/v3/providers/LanguageProvider';
import { handleSessionActivity } from 'src/services/analytics/session';
import { AnalyticsEvent, trackAnalyticsEvent } from 'src/services/analytics';
import { UnionOmit } from 'src/types/unionOmit';

const useAnalyticsTracking = () => {
  const { currentLanguage } = useContext(LanguageContext);

  return (analyticsEvent: UnionOmit<AnalyticsEvent, 'superProperties'>) => {
    trackAnalyticsEvent({
      ...analyticsEvent,
      superProperties: {
        languageCode: currentLanguage,
        sessionId: handleSessionActivity(),
      },
    });
  };
};

export default useAnalyticsTracking;
